import React from 'react'
import styled from 'styled-components'
import Truncate from 'react-truncate'

import { media } from '../../../styles/media'

import Avatar from '../../../components/display/Avatar'
import LazyImage from '../../../components/display/LazyImage'
import Badge from '../../../components/display/Badge'

import Button from '../../../components/display/Button'

import { isPublished } from '../../../components/utils/listingUtils'

export const ListingUserWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  ${Avatar} {
    width: 80px;
    height: 80px;
  }

  ${Button} {
    display: inline-block;
  }

  ${Badge} {
    border-radius: 5px;
  }

  ${media.md`
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;

    ${Avatar} {
      width: 200px;
      height: 200px;
    }
  `}
`

const Name = styled.a`
  display: block;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.1;
  margin-bottom: 24px;

  text-decoration: none !important;

  text-align: center;

  ${media.md`
    text-align: left;
  `}
`

const Content = styled.div`
  width: 100%;

  ${Name} {
    display: none;
  }

  ${Button} {
    width: 100%;
  }

  ${media.md`
    flex: 1;
    width: auto;

    ${Name} {
      display: block;
    }

    ${Button} {
      width: auto;
    }
  `}
`

const Details = styled.div`
  display: flex;
  flex-wrap: wrap;
  color: #999;
  margin-bottom: 16px;
`

const Detail = styled.div`
  width: 50%;
  margin-bottom: 8px;

  .icon {
    color: ${({ theme }) => theme.brand.jungle};
    margin-right: 8px;
  }

  ${Badge} {
    margin-left: 0;
    margin-right: 8px;
  }

  ${media.md`
    width: auto;
    margin-right: 16px;
  `}
`

const Description = styled.div`
  margin-bottom: 24px;
  letter-spacing: normal;
`

const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;

  width: 100%;
  margin-bottom: 32px;

  ${Avatar} {
    margin-right: 16px;
  }

  ${Name} {
    margin: 0;
  }

  ${media.md`
    width: auto;
    margin: 0;
    ${Avatar} {
      margin-right: 40px;
    }
    ${Name} {
      display: none;
    }
  `}
`

export default ({ listing, listing: { user } }) => (
  <ListingUserWrapper>
    <AvatarWrapper>
      <Avatar>
        <LazyImage data-src={user.avatar.large} />
        <noscript>
          <LazyImage className="lazyloaded" src={user.avatar.large} />
        </noscript>
      </Avatar>
      <Name href={user.url}>{user.first_name}</Name>
    </AvatarWrapper>
    <Content>
      <Name href={user.url}>{user.first_name}</Name>
      <Details>
        {user.email_verified && (
          <Detail>
            <i className="icon icon-tick" />
            <span>Email Verified</span>
          </Detail>
        )}
        {user.phone_number_verified && (
          <Detail>
            <i className="icon icon-tick" />
            <span>Phone Verified</span>
          </Detail>
        )}
        {user.facebook_verified && (
          <Detail>
            <i className="icon icon-tick" />
            <span>Facebook Verified</span>
          </Detail>
        )}
        <Detail>
          <i className="icon icon-location" />
          <span>{user.location}</span>
        </Detail>
        <Detail>
          <Badge>{user.listing_count}</Badge>
          <span>Listings</span>
        </Detail>
      </Details>

      <Description>
        <Truncate lines={3} trimWhitespace>
          {user.description}
        </Truncate>
      </Description>

      <Button
        as="a"
        href={`/conversations?listing_id=${listing.id}`}
        disabled={!isPublished(listing)}
      >
        <i className="icon icon-message" />
        Ask a Question
      </Button>
    </Content>
  </ListingUserWrapper>
)
